"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Alert = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lab = require("@material-ui/lab");
var _core = require("@material-ui/core");
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Componente primário de interação com o usuário
 */
const Alert = _ref => {
  let {
    children,
    severity,
    variant
  } = _ref;
  const classes = (0, _styles.useStyles)();
  return /*#__PURE__*/_react.default.createElement(_lab.Alert, {
    classes: classes,
    severity: severity,
    variant: variant
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, null, " ", children, " "));
};
exports.Alert = Alert;
Alert.propTypes = {
  /**
   * Texto do Alerta (título não incluso)
   */
  children: _propTypes.default.string.isRequired,
  /**
   * Define a cor e o ícone do alerta
   */
  severity: _propTypes.default.oneOf(['error', 'warning', 'info', 'success']).isRequired,
  /**
   * Define a variante do alerta
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined'])
};
Alert.defaultProps = {
  variant: 'standard'
};
var _default = exports.default = Alert;